import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FormContainerComponent } from './form-container.component';


@NgModule({
  declarations: [FormContainerComponent],
  imports: [
    CommonModule,
    MatProgressBarModule
  ],
  exports: [FormContainerComponent]
})
export class FormContainerModule { }
